const event={
    duplicateSourceEid:null,
    isOpenLocaleStep:null,
};

export default event;